export default function (state) {
    let date = new Date();
    state.dateType = 1;
    state.dates = [
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ];
    state.CurrencyId = [];
    state.PayStates = [];
    state.InvoiceSumFrom = 0;
    state.InvoiceSumTo = 0;
    state.ContragentID = '';
    state.ContragentName = '';
    state.ContragentType = '';
    state.RegularPaymentTypeId = '';
    state.AgreementCode = '';
    state.AccountNumber = '';
    state.PaymentOperationID = '';
    state.CategoryId = '';
    state.PaymentTypeId = '';
    state.CashId = '';
    state.PaymentAccountId = '';
    state.LatePayments = false;
    state.OnlyAccepted = false;
}